module.exports = __webpack_public_path__ + "static/slide-2-acd8e0166a120a808a1b614552963d44.jpg";